import React from "react";
import "./index.css";
import DommusLogo from "../../assets/Logo_Dommus_Conecta.png";

export function DommusPlaceholderDetalhesAtendimento(){
  return (
    <div className="dommus-placeholder-section">
      <img src={DommusLogo} alt="Dommus" className="dommus-logo-placeholder"/>
    </div>
  )
}
